<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  data() {
    return {
      id: this.$route.params.id ? this.$route.params.id : null,
      indicator: process.env.VUE_APP_INDICATOR_COLOUR
        ? process.env.VUE_APP_INDICATOR_COLOUR
        : "white",
    };
  },
  computed: {
    savingForm() {
      return this.$store.getters[`commons/savingForm`];
    },
    savingError() {
      return this.$store.getters[`commons/savingErrorMessage`];
    },
    activeMenu() {
      if (this.$route.path == "/analytics") {
        return 4;
      }
      if (this.$route.path == "/todo") {
        return 3;
      }
      if (this.$route.path != "/") {
        return 2;
      }
      return 1;
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("is_admin");
      localStorage.removeItem("refresh");
      localStorage.removeItem("access");
      this.$router.push("/login");
    },
  },
  watch: {
    savingForm(newSavingForm) {
      if (newSavingForm) {
        this.$store.commit(`commons/setSavingErrorMessage`, "");
        setTimeout(() => {
          this.$store.commit(`commons/setSavingForm`, false);
          this.$store.commit(`${this.currentType}/setTabStatus`, false);
        }, 5000);
      }
    },
    savingError(newError) {
      if (newError) {
        this.$store.commit(`commons/setSavingForm`, "");
        setTimeout(() => {
          this.$store.commit(`commons/setSavingErrorMessage`, false);
          this.$store.commit(`${this.currentType}/setTabStatus`, false);
        }, 5000);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
nav {
  background: #fff;
  border-bottom: 1px solid #efefef;
  padding: 0 25px 4px !important;
  text-transform: uppercase;
  z-index: 12;
  position: fixed !important;
  width: 100%;
  height: 64px;

  .logo {
    font-size: 18px;
    font-family: "Lato-Light";
    b {
      font-family: "Lato-Black";
    }
  }

  .navbar-nav {
    position: initial !important;
    ul {
      .nav-item {
        position: initial !important;
        margin: 0 5px;
        &.active {
          .nav-link {
            position: relative;
            &:before {
              background: #3f9698;
              border-radius: 0px 0px 4px 4px;
              content: " ";
              position: absolute;
              top: 0;
              width: 100%;
              right: 0;
              height: 4px;
            }
          }
        }
        .nav-link {
          color: #3f9698 !important;
          font-family: "Lato-Bold";
          padding: 18px;
          position: relative;
          border: 0 !important;
          outline: none !important;
          &:before {
            background: #fff;
            border-radius: 0px 0px 4px 4px;
            content: " ";
            position: absolute;
            top: 0;
            width: 100%;
            right: 0;
          }

          &:after {
            margin-left: 10px;
            border-top: 0;
            border-left: 0;
            border-right: 2px solid #3f9698 !important;
            border-bottom: 2px solid #3f9698 !important;
            width: 10px;
            height: 10px;
            transform: rotate(45deg);
            margin-top: 0;
          }
        }
        .dropdown-menu {
          position: absolute;
          z-index: 1;
          background: #fff;
          width: 100%;
          border-radius: 0;
          border: 0;
          left: 0;
          text-align: center;
          li {
            display: inline-block !important;
            a {
              color: #3f9698;
              font-family: "Lato-Bold";
              font-size: 13px;
              padding: 20px;
              background: #fff !important;
            }
          }
        }

        &.show {
          .nav-link {
            &:after {
              transform: rotate(-135deg);
              margin-bottom: -6px;
            }
          }
        }
      }
    }
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #efefef;
  }

  .no-arrow {
    .dropdown-toggle {
      &:after {
        display: none;
      }
    }
  }

  &.dark-text {
    .navbar-nav {
      ul {
        .nav-item {
          .nav-link {
            color: rgba(0, 0, 0, 0.9) !important;

            &:after {
              border-right: 2px solid #000 !important;
              border-bottom: 2px solid #000 !important;
            }
          }
          &.active {
            .nav-link {
              &:before {
                background: rgba(0, 0, 0, 0.9) !important;
              }
            }
          }
        }
      }
    }
  }
}
.text-default {
  a {
    color: #6c757d !important;
  }
}
.status {
  text-transform: capitalize;
  display: none;
  &.saved {
    color: #469a2e;
    display: block;
  }
  &.error {
    display: block;
    color: red;
  }
}
</style>

<template>
  <b-navbar
    toggleable="lg"
    :style="{ background: indicator }"
    :class="indicator == '#3f9698' ? 'dark-text' : ''"
  >
    <b-navbar-brand href="/" class="logo"
      ><b>XALI</b> ADMIN</b-navbar-brand
    >
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav class="ml-auto">
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto col-md-12 pr-0">
        <b-navbar-nav class="mx-auto">
          <b-nav-item href="/" :class="activeMenu == 1 ? 'active' : ''"
            >Search</b-nav-item
          >
          <b-nav-item-dropdown
            text="Create"
            right
            :class="activeMenu == 2 ? 'active' : ''"
          >
            <b-dropdown-item :href="'#/create-workout'">
              Workout
            </b-dropdown-item>
            <b-dropdown-item href="#/create-warmup">Warm up</b-dropdown-item>
            <b-dropdown-item href="#/create-stretch-flow">
              stretch flow
            </b-dropdown-item>
            <b-dropdown-item href="#/recipe/create">recipe</b-dropdown-item>
            <b-dropdown-item href="#/learn/create">LEARN</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="#/todo" :class="activeMenu == 3 ? 'active' : ''">
            To Do List
          </b-nav-item>
          <b-nav-item href="#/analytics" :class="activeMenu == 4 ? 'active' : ''">
            Analytics
          </b-nav-item>
        </b-navbar-nav>
        <div
          class="status"
          :class="savingForm ? 'saved d-flex align-items-center' : ''"
        >
          <span class="pr-1">
            <b-icon icon="check" aria-hidden="true" scale="1.3"></b-icon>
          </span>
          {{ savingForm }}
        </div>
        <div
          class="status"
          :class="savingError ? 'error d-flex align-items-center' : ''"
        >
          <span class="pr-1"
            ><b-icon icon="x" aria-hidden="true" scale="1.3"></b-icon
          ></span>
          {{ savingError }}
        </div>
        <b-nav-item-dropdown right class="no-arrow">
          <template #button-content>
            <div class="avatar"></div>
          </template>
          <b-dropdown-item href="#">Profile</b-dropdown-item>
          <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>